import { useState, useEffect } from "react";
import { useAuthContext } from "./useAuthContext";
import getAuthHeaders from "../utils/getAuthHeaders";
import reportError from "../utils/reportError";

export const usePreviousOrder = () => {
  const { user: authUser } = useAuthContext();
  const [previousOrderInfo, setPreviousOrderInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (authUser) {
      const checkPreviousOrder = async () => {
        try {
          setIsLoading(true);
          const authHeader = await getAuthHeaders(authUser);
          let url = `/api/orders/user/${authUser.uid}`;

          if (process.env.NODE_ENV === "development") {
            url = `${process.env.REACT_APP_NETWORK}${url}`;
          }

          const requestOptions = {
            method: "GET",
            headers: {
              ...authHeader,
            },
          };

          const res = await fetch(url, requestOptions);
          const previousOrders = await res.json();

          if (previousOrders.length >= 1) {
            const sortedOrders = previousOrders.sort((a, b) => {
              const timeA = new Date(a.orderTimestamp || 0).getTime();
              const timeB = new Date(b.orderTimestamp || 0).getTime();
              return timeB - timeA;
            });

            const prevFul = sortedOrders[0].fulfillment || {};
            const orderDeadline = prevFul.orderDeadline;

            // Compare dates at midnight to include today as valid
            let isDeadlineFuture = false;
            if (orderDeadline) {
              const deadlineDate = new Date(orderDeadline);
              const today = new Date();
              deadlineDate.setHours(0, 0, 0, 0);
              today.setHours(0, 0, 0, 0);
              isDeadlineFuture = deadlineDate >= today;
            }

            if (isDeadlineFuture) {
              const daysLeft = Math.ceil(
                (new Date(orderDeadline) - new Date()) / (1000 * 60 * 60 * 24)
              );
              setPreviousOrderInfo({
                ...prevFul, // Include all fulfillment details
                daysRemaining: daysLeft,
              });
            } else {
              setPreviousOrderInfo(null);
            }
          }
          setIsLoading(false);
        } catch (err) {
          reportError(err, "check previous order");
          setIsLoading(false);
        }
      };

      checkPreviousOrder();
    } else {
      setIsLoading(false);
    }
  }, [authUser]);

  return { previousOrderInfo, isLoading };
};
